import Vue from 'vue'
import VueRouter from 'vue-router'

import LayoutDefault from '@/layouts/default/Index.vue'
import LayoutBase from '@/layouts/base/Index.vue'

import SignInView from '../views/sign-in/Index.vue'
import HomeAppBar from '../views/home/AppBar.vue'
import HomeView from '../views/home/Index.vue'
import FiltersHome from '../views/home/Filters.vue'
import ConfigView from '../views/configuracao/Index.vue'
import PedidoAppBar from '../views/pedido/pedido/AppBar.vue'
import PedidoView from '../views/pedido/pedido/Index.vue'
import FiltersPedido from '../views/pedido/pedido/Filters.vue'
import SincronizarAppBar from '../views/sincronizar/sincronizar/AppBar.vue'
import SincronizarView from '../views/sincronizar/sincronizar/Index.vue'
import ProdutosAppBar from '../views/produtos/produtos/AppBar.vue'
import ProdutosView from '../views/produtos/produtos/Index.vue'
import FiltersProdutos from '../views/produtos/produtos/Filters.vue'
import ClientesAppBar from '../views/clientes/clientes/AppBar.vue'
import ClientesView from '../views/clientes/clientes/Index.vue'
import FiltersClientes from '../views/clientes/clientes/Filters.vue'
import ListaprecadastroAppBar from '../views/clienteprecadastro/listaprecadastro/AppBar.vue'
import ListaprecadastroView from '../views/clienteprecadastro/listaprecadastro/Index.vue'
import FiltersListaprecadastro from '../views/clienteprecadastro/listaprecadastro/Filters.vue'
import PrecadastroAppBar from '../views/clienteprecadastro/precadastro/AppBar.vue'
import PrecadastroView from '../views/clienteprecadastro/precadastro/Index.vue'
import DiversosAppBar from '../views/diversos/diversos/AppBar.vue'
import DiversosView from '../views/diversos/diversos/Index.vue'
import FiltersPesquisaCadastro from '../views/pedido/pesquisacondicaopagamento/Filters.vue'
import FiltersCadastroPedidoproduto from '../views/pedido/cadastropedidoproduto/Filters.vue'
import CadastroPedidoAppBar from '../views/pedido/cadastropedido/AppBar.vue'
import CadastroPedidoView from '../views/pedido/cadastropedido/Index.vue'
import pesquisacondicaopagamentoAppBar from '../views/pedido/pesquisacondicaopagamento/AppBar.vue'
import pesquisacondicaopagamentoView from '../views/pedido/pesquisacondicaopagamento/Index.vue'
import PesquisaClienteAppBar from '../views/pedido/pesquisacliente/AppBar.vue'
import PesquisaClienteView from '../views/pedido/pesquisacliente/Index.vue'
import FiltersPesquisaCliente from '../views/pedido/pesquisacliente/Filters.vue'
import PesquisaFinanceiroClienteAppBar from '../views/pedido/pesquisafinanceiro/AppBar.vue'
import PesquisaFinanceiroClienteView from '../views/pedido/pesquisafinanceiro/Index.vue'
import PesquisaFiltroProdutoAppBar from '../views/pedido/pesquisafiltroproduto/AppBar.vue'
import PesquisaFiltroProdutoView from '../views/pedido/pesquisafiltroproduto/Index.vue'
import CadastroPedidoItemAppBar from '../views/pedido/cadastropedidoitem/AppBar.vue'
import CadastroPedidoItemView from '../views/pedido/cadastropedidoitem/Index.vue'
import CadastroPedidoProdutoAppBar from '../views/pedido/cadastropedidoproduto/AppBar.vue'
import CadastroPedidoProdutoView  from '../views/pedido/cadastropedidoproduto/Index.vue'
import PesquisaVisitaClienteAppBar from '../views/pedido/pesquisavisitacliente/AppBar.vue'
import PesquisaVisitaClienteView  from '../views/pedido/pesquisavisitacliente/Index.vue'
import DiversosResumoAppBar from '../views/diversos/diversosresumo/AppBar.vue'
import DiversosResumoView  from '../views/diversos/diversosresumo/Index.vue'
import FiltersDiversos from '../views/diversos/diversosresumo/Filters.vue'
import CargaTotalAppBar from '../views/sincronizar/cargaTotal/AppBar.vue'
import CargaTotalView from '../views/sincronizar/cargaTotal/Index.vue'
import ImpressaoVendaAppBar from '../views/pedido/impressaopedido/AppBar.vue'
import impressaoVendaView from '../views/pedido/impressaopedido/Index.vue'
import SincronizarEnviarAppBar from '../views/sincronizar/sincronizar_enviar/AppBar.vue'
import SincronizarEnviarView from '../views/sincronizar/sincronizar_enviar/Index.vue'

import { ROUTE_SIGN_IN } from '@/constants/ROUTES';
import { TOKENLOCAL } from '@/constants/STORAGE'

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

function validaToken(rota, next) {
  const token = getSessionStorage(TOKENLOCAL.tokenlocal);

  if (!token) {
    next({ path: rota });
  } else {
    next();
  }
}

// import BaseLayout from '../layouts/base/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: HomeAppBar,
        default: HomeView,
        filters: FiltersHome,
      },
      name: 'home',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/pedido',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PedidoAppBar,
        default: PedidoView,
        filters: FiltersPedido,
      },
      name: 'pedido',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/sincronizar',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: SincronizarAppBar,
        default: SincronizarView,
        filters: FiltersPedido,
      },
      name: 'sincronizar',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/produtos',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ProdutosAppBar,
        default: ProdutosView,
        filters: FiltersProdutos,
      },
      name: 'produtos',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/clientes',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ClientesAppBar,
        default: ClientesView,
        filters: FiltersClientes,
      },
      name: 'clientes',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/listaprecadastro',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ListaprecadastroAppBar,
        default: ListaprecadastroView,
        filters: FiltersListaprecadastro,
      },
      name: 'listaprecadastro',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/precadastro',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PrecadastroAppBar,
        default: PrecadastroView,
      },
      name: 'precadastro',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/diversos',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: DiversosAppBar,
        default: DiversosView,
      },
      name: 'diversos',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/cadastro-pedido',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroPedidoAppBar,
        default: CadastroPedidoView,
      },
      name: 'cadastropedido',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  

  {
    path: '/pesquisa-cadastro-pedido',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: pesquisacondicaopagamentoAppBar,
        default: pesquisacondicaopagamentoView,
        filters: FiltersPesquisaCadastro,
      },
      name: 'pesquisa-cadastro-pedido',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/pesquisa-cadastro-cliente',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PesquisaClienteAppBar,
        default: PesquisaClienteView,
        filters: FiltersPesquisaCliente,
      },
      name: 'pesquisa-cadastro-cliente',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/pesquisa-financeiro-cliente',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PesquisaFinanceiroClienteAppBar,
        default: PesquisaFinanceiroClienteView,
      },
      name: 'pesquisa-financeiro-cliente',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/pesquisa-filtro-produto',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PesquisaFiltroProdutoAppBar,
        default: PesquisaFiltroProdutoView,
      },
      name: 'pesquisa-filtro-produto',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/cadastro-pedido-item',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroPedidoItemAppBar,
        default: CadastroPedidoItemView,
      },
      name: 'cadastro-pedido-item',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/cadastro-pedido-produto',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroPedidoProdutoAppBar,
        default: CadastroPedidoProdutoView,
        filters: FiltersCadastroPedidoproduto,
      },
      name: 'cadastro-pedido-produto',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/pesquisa_visita_cliente',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PesquisaVisitaClienteAppBar,
        default: PesquisaVisitaClienteView,
      },
      name: 'pesquisa_visita_cliente',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/impressao_pedido',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ImpressaoVendaAppBar,
        default: impressaoVendaView,
      },
      name: 'impressao_pedido',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/diversos_resumo',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: DiversosResumoAppBar,
        default: DiversosResumoView,
        filters: FiltersDiversos,
      },
      name: 'diversos_resumo',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/carga_total',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CargaTotalAppBar,
        default: CargaTotalView,
      },
      name: 'carga_total',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  {
    path: '/sincronizar_enviar',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: SincronizarEnviarAppBar,
        default: SincronizarEnviarView,
      },
      name: 'sincronizar_enviar',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },

  redirectRoute('/'),

  {
    path: '/',
    component: LayoutBase,
    children: [{
      components: {
        default: SignInView,
      },
      name: 'signin',
      path: '',
    }],
  },

  {
    path: '/config',
    component: LayoutBase,
    children: [{
      components: {
        default: ConfigView,
      },
      name: 'config',
      path: '',
    }],
  },
  redirectRoute('/'),
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export function redirectRoute(redirect) {
  return {
    path: '*',
    redirect,
  };
}

export default router
